import { call, put, takeEvery } from "redux-saga/effects";

import { PaginateQuery, ResponseGenerator } from "../../../interfaces";
import {
  ADD_TEACHER_ADMIN_USER,
  AddTeacherAdminUserAction,
  DELETE_TEACHER_ADMIN_USER,
  DeleteTeacherAdminUserAction,
  GET_TEACHER_ADMIN_USER,
  GET_TEACHER_ADMIN_USERS,
  GetTeacherAdminUserAction,
  GetTeacherAdminUsersAction,
  UPDATE_TEACHER_ADMIN_USER,
  UpdateTeacherAdminUserAction,
} from "./actionTypes";
import {
  addTeacherAdminUserError,
  addTeacherAdminUserSuccess,
  deleteTeacherAdminUserError,
  deleteTeacherAdminUserSuccess,
  getTeacherAdminUserError,
  getTeacherAdminUserSuccess,
  getTeacherAdminUsersError,
  getTeacherAdminUsersSuccess,
  updateTeacherAdminUserError,
  updateTeacherAdminUserSuccess,
} from "./actions";
import {
  addTeacherAdminUser,
  deleteTeacherAdminUser,
  getTeacherAdminUser,
  getTeacherAdminUsers,
  toggleBlockUser,
  updateTeacherAdminUser,
} from "../../../helpers/backend_helper";

function* getTeacherAdminUsersSaga({
  payload: { request, history, role },
}: GetTeacherAdminUsersAction) {
  try {
    const response: ResponseGenerator = yield call(
      getTeacherAdminUsers,
      role,
      request as PaginateQuery
    );
    yield put(getTeacherAdminUsersSuccess(response.data));
  } catch (error) {
    yield put(getTeacherAdminUsersError(error));
  }
}

function* getTeacherUserSaga({
  payload: { id, history },
}: GetTeacherAdminUserAction) {
  try {
    const response: ResponseGenerator = yield call(getTeacherAdminUser, id);
    yield put(getTeacherAdminUserSuccess(response.data));
  } catch (error) {
    yield put(getTeacherAdminUserError(error));
  }
}

function* addTeacherAdminUserSaga({
  payload: { request, history },
}: AddTeacherAdminUserAction) {
  try {
    yield call(addTeacherAdminUser, request);
    yield put(addTeacherAdminUserSuccess());
  } catch (error) {
    yield put(addTeacherAdminUserError(error));
  }
}

function* updateTeacherAdminUserSaga({
  payload: { id, request, history },
}: UpdateTeacherAdminUserAction) {
  try {
    yield call(updateTeacherAdminUser, id, request);
    yield put(updateTeacherAdminUserSuccess());
  } catch (error) {
    yield put(updateTeacherAdminUserError(error));
  }
}

function* deleteTeacherAdminUserSaga({
  payload: { id, history },
}: DeleteTeacherAdminUserAction) {
  try {
    yield call(deleteTeacherAdminUser, id);
    yield put(deleteTeacherAdminUserSuccess());
  } catch (error) {
    yield put(deleteTeacherAdminUserError(error));
  }
}

function* TeacherAdminSaga() {
  yield takeEvery(GET_TEACHER_ADMIN_USERS, getTeacherAdminUsersSaga);
  yield takeEvery(GET_TEACHER_ADMIN_USER, getTeacherUserSaga);
  yield takeEvery(ADD_TEACHER_ADMIN_USER, addTeacherAdminUserSaga);
  yield takeEvery(UPDATE_TEACHER_ADMIN_USER, updateTeacherAdminUserSaga);
  yield takeEvery(DELETE_TEACHER_ADMIN_USER, deleteTeacherAdminUserSaga);
}

export default TeacherAdminSaga;
